import React from "react"

const Card = ({ children, as=false, className, id }) => {
  as = `${as ? `${as}`: 'div'}`
  className = `card${className ? ` ${className}`: '' }`
 return React.createElement(as, {className:className, id:id}, children)
}
export default Card
